import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { capitalize, Chip, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { IRecommendationItem, RecommendationStatus } from "store/types";

import { useAiDataContext } from "../context/AiData-context";

export const statusIcons = {
  [RecommendationStatus.declined]: <CloseIcon sx={{ color: "#D93E3E !important" }} />,
  [RecommendationStatus.accepted]: <DoneIcon sx={{ color: "#07A27D !important" }} />,
  [RecommendationStatus.new]: <InfoOutlined />
};

interface Props {
  status: RecommendationStatus | null;
  parameter: IRecommendationItem;
}

export const UpdateStatusDropdown: React.FC<Props> = ({ status, parameter }) => {
  const { onChangeRecommendationStatus, isRecommendationWithChildrenFilled } = useAiDataContext();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const options = [
    {
      label: "Accepted",
      value: RecommendationStatus.accepted
    },
    {
      label: "New",
      value: RecommendationStatus.new
    },
    {
      label: "Declined",
      value: RecommendationStatus.declined
    }
  ];

  if (parameter.status !== RecommendationStatus.declined) {
    return (
      <Chip
        label={capitalize(parameter.status) || "-"}
        icon={statusIcons[parameter.status]}
        sx={{
          background: "#F6F8FC",
          borderRadius: "15px",
          "& .MuiChip-label": {
            fontSize: "16px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }
        }}
      />
    );
  }
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = async (option: (typeof options)[0]) => {
    if (parameter.id && option.value !== RecommendationStatus.declined) {
      await onChangeRecommendationStatus(option.value, parameter.id);
    }
    handleClose();
  };

  const currentOption = options.find((option) => option.value === status);

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Chip
        label={currentOption?.label || "Select Status"}
        onClick={handleClick}
        icon={currentOption ? statusIcons[currentOption.value] : undefined}
        variant="outlined"
        sx={{
          minWidth: "120px",
          justifyContent: "flex-start",
          "& .MuiChip-label": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            disabled={option.value === RecommendationStatus.accepted && !isRecommendationWithChildrenFilled(parameter)}
            onClick={() => handleSelect(option)}
            sx={{ gap: "10px", minWidth: "120px" }}
          >
            {statusIcons[option.value]}
            <Typography>{option.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
};
